import { render, staticRenderFns } from "./OrdersPullList.vue?vue&type=template&id=1f9202cb&scoped=true&"
import script from "./OrdersPullList.vue?vue&type=script&lang=js&"
export * from "./OrdersPullList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9202cb",
  null
  
)

export default component.exports